import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BarChart3, ChevronRight, Wallet } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { UI_MUTED, UI_SECTION } from '@/lib/typography';

export function ReportsHome() {
  const { t } = useTranslation();

  return (
    <div className="space-y-s4">
      <div>
        <h2 className={UI_SECTION}>{t('reports.back')}</h2>
        <p className={`mt-s1 ${UI_MUTED}`}>{t('reports.subtitle')}</p>
      </div>

      <Link to="/economy/reports/practitioner" className="block">
        <Card className="flex items-start gap-s4 transition hover:bg-ds-sunk">
          <div className="flex h-10 w-10 items-center justify-center rounded-ctl bg-ds-teal-tint text-ds-teal">
            <BarChart3 className="h-5 w-5" aria-hidden />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className={UI_SECTION}>{t('reports.types.practitioner.label')}</h3>
            <p className={`mt-s1 ${UI_MUTED}`}>{t('reports.types.practitioner.description')}</p>
          </div>
          <ChevronRight className="mt-s1 h-5 w-5 text-ds-muted" aria-hidden />
        </Card>
      </Link>

      <Link to="/economy/reports/cashier" className="block">
        <Card className="flex items-start gap-s4 transition hover:bg-ds-sunk">
          <div className="flex h-10 w-10 items-center justify-center rounded-ctl bg-ds-teal-tint text-ds-teal">
            <Wallet className="h-5 w-5" aria-hidden />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className={UI_SECTION}>{t('reports.types.cashier.label')}</h3>
            <p className={`mt-s1 ${UI_MUTED}`}>{t('reports.types.cashier.description')}</p>
          </div>
          <ChevronRight className="mt-s1 h-5 w-5 text-ds-muted" aria-hidden />
        </Card>
      </Link>
    </div>
  );
}
